import React from "react"

import BackgroundImage from "../../../common/BackgroundImage"
import ContentLoaderLines from "../../../common/content-loading/ContentLoaderLines"

const ClusterViewItemDetails = ({
    title,
    image_url,
    description,
    time,
    isFetching
}) => (
    <div className="widget">
        <div className="widget-content">
            <h3 className="first-heading">
                <i className="icon icon-headline" />
                Title
            </h3>
            <ContentLoaderLines
                isFetching={isFetching}
                minLineLength={30}
                maxLineLength={60}
            >
                <p>{title || "No title"}</p>
            </ContentLoaderLines>
            <h3>
                <i className="icon icon-headline" />
                Time
            </h3>
            <ContentLoaderLines isFetching={isFetching}>
                <p>{time.local().format("llll")}</p>
            </ContentLoaderLines>
            <h3>
                <i className="icon icon-headline" />
                Description
            </h3>
            <ContentLoaderLines
                isFetching={isFetching}
                minLines={1}
                maxLines={2}
            >
                <p>{description || "No description"}</p>
            </ContentLoaderLines>
            <h3>
                <i className="icon icon-heroimg" />
                Image
            </h3>
            <BackgroundImage
                imageUrl={image_url}
                classList={["item-background-image"]}
            />
        </div>
    </div>
)

export default ClusterViewItemDetails
